// extracted by mini-css-extract-plugin
export default {"category_container":"style_category_container__7Urbq","photo_category_container":"style_photo_category_container__Ijwpy","block":"style_block__2hS+0","slider":"style_slider__+TOWc"};